function getLinkApiTemplate(linkApiResponse) {
    if (!linkApiResponse)
        return null;
    if (linkApiResponse.responseType !== 'next' &&
        linkApiResponse.responseType !== 'next_with_error')
        return null;
    return linkApiResponse.template;
}
export var getLinkApiTemplateType = function (linkApiResponse) {
    var template = getLinkApiTemplate(linkApiResponse);
    if (template)
        return template.templateType;
    return null;
};
/**
 * Returns link api template with actions or false if no actions are present
 * @param linkApiResponse - any link api response
 * @returns - link api template with actions or false
 */
export var getLinkApiTemplateWithActions = function (linkApiResponse) {
    var template = getLinkApiTemplate(linkApiResponse);
    if (template && 'actions' in template) {
        return template;
    }
    return null;
};
export var shouldLinkApiTemplateHideLogos = function (linkApiTemplateWithActions, linkApiTemplateType) {
    return (['provider_selection', 'search'].includes(linkApiTemplateType) ||
        (linkApiTemplateType === 'continue' &&
            'imageUrl' in linkApiTemplateWithActions &&
            linkApiTemplateWithActions.imageUrl));
};
